// FINAL X p2-7: the splash screen gains a 3-state logo layout, a title colour
// and a gradient.
//
// These are NEW keys on purpose. `splashScreen` and `splashScreenTitle` are
// also the AllGamesMenu header logo and title, so styling written onto them
// would leak onto that screen. `upsertResourcesAndTranslations` dedupes on
// key+type+language, which means renaming an existing key creates a second row
// rather than migrating the first — there is no safe in-place rename.

const baseColorContent = {
  type: "color",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "splashScreenStyle",
    file: {},
    isUpdated: false,
    colorMix: {
      flag: true,
      color1: "#000000",
      color2: "#000000",
      isUpdated: false,
    },
  },
  translation: {
    id: "",
    name: "",
    translationableId: "",
    translationableType: "Resource",
    adminId: "",
    languageId: "",
    flag: false,
    isUpdated: false,
  },
};

const baseInputContent = {
  type: "input",
  inputType: "number",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "splashScreenStyle",
    file: {},
    isUpdated: false,
  },
  translation: {
    input: "",
    flag: false,
    isUpdated: false,
  },
};

const createColorEntry = (title: string, key: string, label: string) => ({
  title,
  content: {
    ...baseColorContent,
    label,
    data: {
      ...baseColorContent.data,
      key,
      colorMix: { ...baseColorContent.data.colorMix },
    },
    translation: { ...baseColorContent.translation },
  },
  isRequired: false,
  readonly: false,
  isButton: false,
});

const createInputEntry = (title: string, key: string, label: string) => ({
  title,
  content: {
    ...baseInputContent,
    label,
    data: { ...baseInputContent.data, key },
    translation: { ...baseInputContent.translation },
  },
  isRequired: false,
  readonly: false,
  isButton: false,
});

const baseImageContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "splashScreenStyle",
    file: {},
    isUpdated: false,
  },
  translation: {
    input: "",
    flag: false,
    isUpdated: false,
  },
};

const createImageEntry = (title: string, key: string, label: string = "") => ({
  title,
  content: {
    ...baseImageContent,
    label,
    data: { ...baseImageContent.data, key },
    translation: { ...baseImageContent.translation },
  },
  isRequired: false,
  readonly: false,
  isButton: true,
});

// State 1 is the existing behaviour, so an unset or unrecognised value must
// render exactly as the app does today — the app treats anything that is not
// 2 or 3 as 1.
const splashScreenStyles = [
  createInputEntry(
    "Splash Screen Logo Layout",
    "splashScreenLogoState",
    "1 = logo beside the title (default), 2 = logo above the title, 3 = logo fills the screen",
  ),
  createColorEntry(
    "Splash Screen Title Color",
    "splashScreenTitleColor",
    "Color 1 is the title colour; Color 2 is ignored",
  ),
  createColorEntry(
    "Splash Screen Gradient",
    "splashScreenGradient",
    "Background gradient behind the splash screen",
  ),
  createImageEntry(
    "Splash Screen Image Upload",
    "splashScreenImage",
    "Upload Splash Screen Image",
  ),
];

export { splashScreenStyles };
